/*
  meluya-pdp-core.js
  Gemeinsame PDP-Utilities fuer die Custom-Bloecke (Preis, Quantity-Discount,
  Upsell, Set-Selector). Ziel: EINE Quelle fuer
    - getCurrentVariantId()
    - readVariantMap(scriptId)
    - formatCents(cents, opts)
    - onVariantChange(cb)  -> EINE zentrale Variant-Wechsel-Erkennung
  statt N kopierte Helfer + N parallele 250ms-Polling-Loops in jedem Block.

  Konfiguration kommt aus window.MeluyaPDPConfig (in product-info.liquid via
  Liquid gesetzt: moneyFormat, currency).
*/
(function () {
  'use strict';
  if (window.MeluyaPDP) return;

  var cfg = window.MeluyaPDPConfig || {};
  var MONEY_FORMAT = cfg.moneyFormat || '${{amount}}';
  var CURRENCY = cfg.currency || 'EUR';

  function getCurrentVariantId(form) {
    var f = form || document.querySelector('form[action="/cart/add"]');
    var idInput = f ? f.querySelector('input[name="id"]') : null;
    if (idInput && idInput.value) return String(idInput.value);
    var u = new URLSearchParams(location.search).get('variant');
    return u ? String(u) : null;
  }

  function readVariantMap(scriptId) {
    try {
      var el = document.getElementById(scriptId);
      return JSON.parse((el && el.textContent) || '{}') || {};
    } catch (e) { return {}; }
  }

  // Identisch zur bisherigen fmt()-Logik der Bloecke.
  function formatCents(cents, opts) {
    opts = opts || {};
    var showCode = !!opts.showCode;
    var currency = opts.currency || CURRENCY;
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var s = Shopify.formatMoney(cents, MONEY_FORMAT);
      if (showCode && !/\b[A-Z]{3}\b/.test(s)) return s + currency;
      return s;
    }
    var amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return showCode ? amount + currency : amount + '€';
  }

  // ---- EINE zentrale Variant-Wechsel-Erkennung fuer alle Bloecke ----
  var subscribers = [];
  var lastVid = null;
  var started = false;

  function emit() {
    var vid = getCurrentVariantId();
    if (!vid) return;
    if (String(vid) === String(lastVid)) return;
    lastVid = String(vid);
    for (var i = 0; i < subscribers.length; i++) {
      try { subscribers[i](vid); } catch (e) {}
    }
  }

  function deferEmit() {
    // nach dem DOM-Update des Themes nachziehen (wie bisher: doppeltes rAF)
    requestAnimationFrame(function () { requestAnimationFrame(emit); });
  }

  function startDetector() {
    if (started) return;
    started = true;
    lastVid = getCurrentVariantId();

    // 1) Theme-Events (Aurora feuert diese je nach Variante/Setup)
    ['variant:changed', 'variant:change', 'product:variant-change', 'theme:variant:change'].forEach(function (evt) {
      document.addEventListener(evt, deferEmit, true);
    });

    // 2) History-Hook EINMAL global (ersetzt die frueheren Mehrfach-Patches)
    if (!window.__meluyaHistoryHooked) {
      window.__meluyaHistoryHooked = true;
      var wrap = function (fn) {
        return function () {
          var ret = fn.apply(this, arguments);
          window.dispatchEvent(new Event('meluya:locationchange'));
          return ret;
        };
      };
      history.pushState = wrap(history.pushState);
      history.replaceState = wrap(history.replaceState);
      window.addEventListener('popstate', function () {
        window.dispatchEvent(new Event('meluya:locationchange'));
      });
    }
    window.addEventListener('meluya:locationchange', function () { setTimeout(emit, 80); });

    // 3) EIN gemeinsamer Fallback-Poll (ersetzt die je 250ms-Loops pro Block)
    setInterval(emit, 250);
  }

  function onVariantChange(cb) {
    if (typeof cb !== 'function') return function () {};
    subscribers.push(cb);
    startDetector();
    // Unsubscribe-Funktion zurueckgeben (fuer sauberes Aufraeumen)
    return function () {
      var i = subscribers.indexOf(cb);
      if (i > -1) subscribers.splice(i, 1);
    };
  }

  window.MeluyaPDP = {
    getCurrentVariantId: getCurrentVariantId,
    readVariantMap: readVariantMap,
    formatCents: formatCents,
    onVariantChange: onVariantChange
  };
})();
